import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { ProductlogApi, ProductlogDataType } from "@/api/ProductlogApi";
import { Col, Container, Row } from "reactstrap";
import { formatDate } from "@utils/Api";
import { formatCant } from "@utils/Cant";
import LoadingScreen from "@components/content/LoadingScreen";
import { ProductApi, ProductDataType } from "@/api/ProductsApi";

const ProductlogIndex = () => {
  const params = useParams();
  const modelRef = useRef<ModelIndexHandle>(null);
  const { id: productId } = params;
  const [product, setProduct] = useState<ProductDataType>({})
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (productId) {
      const run = async (productId: string) => {
        try {
          const product = await ProductApi.get(productId);
          setProduct(product);
        } finally {
          setIsLoading(false)
        }
      }
      run(productId);
      setIsLoading(true)
    }
  }, [productId]);


  return (
    <PageContainer
      title="Movimientos de Producto"
      backUrl="/user/products"
    >
      <Container fluid>
        <Row>
          <Col xs="2" md="2">
            <h5><b>Product:</b></h5>
          </Col>
          <Col>
            <h5><b>{product?.codigo}</b></h5>
          </Col>
        </Row>
        <Row>
          <Col xs="2" md="2">
            <b>Existencias:</b>
          </Col>
          <Col>
            {formatCant(product?.existencias)}
          </Col>
        </Row>
        <Row>
          <Col xs="2" md="2">
            <b>Descripcion:</b>
          </Col>
          <Col>
            {product?.descripcion_fact}
          </Col>
        </Row>
        <hr />
      </Container>
      <ModelIndex<ProductlogDataType>
        mandatoryFilters={[{ productId: { eq: productId } }]}
        messages={{
          noResults: "No hay Movimientos para este Producto"
        }}
        ref={modelRef}
        fetchData={() => ProductlogApi.getMovementByProduct(`${productId}`)}
        secondaryProperties={[
          {
            key: (data) => {
              return formatDate(data.createdAt)
            },
            title: "Fecha",
          },
          {
            key: "user",
            title: "Usuario",
          },
          {
            key: "previous_amount",
            title: "Previa",
          },
          {
            key: "change_amount",
            title: "Cambio",
            optionalHighlighted: (val: number) => { return val < 0 },
            highlightedColors: {
              "true": {
                "bg": "#dc3545",
                "text": "#fff"
              },
              "false": {
                "bg": "#9cd47d",
                "text": "#fff"
              }
            },
          },
          {
            key: "new_amount",
            title: "Nueva",
            highlighted: true
          },
          {
            key: "comments",
          },
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "3" },
            { sm: "4", md: "3" },
            { sm: "4", md: "2" },
            { sm: "4", md: "2" },
            { sm: "4", md: "2" },
            { sm: "12" }
          ]
        }
      >
      </ModelIndex>
      <LoadingScreen isLoading={isLoading} />
    </PageContainer >
  );
}

export default ProductlogIndex;
